import {utcFormat} from "./defaultLocale";

export var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : utcFormat(isoSpecifier);

export default formatIso;



//////////////////
// WEBPACK FOOTER
// ./~/d3-time-format/src/isoFormat.js
// module id = 306
// module chunks = 4